import _taggedTemplateLiteral from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  transition: transform 0.2s ease-in-out;\n  &.hideDelivery {\n    transform: translateY(-42px);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, useState } from "react";
import { Flex, Text, Box, Span, Alert, IconLocationPin, styled } from "@catchoftheday/cg-components";
import DeliveryLocationPopup from "./DeliveryLocationPopup";
import { jsx as ___EmotionJSX } from "@emotion/react";
var MOBILE_HEADER_HEIGHT = 70;
var DeliveryLocation = styled(Flex)(_templateObject());
export var DeliveryLocationMobile = function DeliveryLocationMobile(_ref) {
  var setShowInput = _ref.setShowInput,
      showInput = _ref.showInput,
      selectedLocation = _ref.selectedLocation,
      handleItemSelected = _ref.handleItemSelected,
      handleAlertHide = _ref.handleAlertHide,
      serverError = _ref.serverError;

  var _useState = useState(false),
      isHidden = _useState[0],
      setIsHidden = _useState[1];

  useEffect(function () {
    var previousScrollPos = 0;

    var onScroll = function onScroll(event) {
      var currentScrollPos = event.target.documentElement.scrollTop;

      if (currentScrollPos > MOBILE_HEADER_HEIGHT && currentScrollPos > previousScrollPos && !showInput) {
        setIsHidden(true);
      } else {
        setIsHidden(false);
      }

      previousScrollPos = currentScrollPos;
    };

    window.addEventListener("scroll", onScroll);
    return function () {
      return window.removeEventListener("scroll", onScroll);
    };
  }, [showInput]);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(DeliveryLocation, {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    "aria-label": "Delivery Location Selector",
    backgroundColor: "secondary",
    p: "10px",
    minHeight: "40px",
    borderTop: "solid 1px",
    borderColor: "ui.borderColor",
    className: isHidden ? "hideDelivery" : ""
  }, ___EmotionJSX(Flex, {
    lineHeight: "1",
    flex: "0 0 auto",
    mr: "4px"
  }, "Delivering to:"), ___EmotionJSX(Flex, {
    width: "100%",
    minHeight: "20px",
    position: "relative",
    flexDirection: "column",
    justifyContent: "center"
  }, ___EmotionJSX(Box, {
    as: "div",
    m: "0px",
    position: "absolute",
    display: "flex",
    borderBottom: "1px solid white",
    maxWidth: "100%",
    maxHeight: "20px",
    onClick: function onClick() {
      return setShowInput(true);
    },
    "aria-label": "Selected Location"
  }, ___EmotionJSX(Span, null, ___EmotionJSX(IconLocationPin, {
    width: "10px",
    height: "12px",
    fill: "white",
    mr: "4px",
    "aria-hidden": "true"
  })), ___EmotionJSX(Text, {
    as: "div",
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textTransform: "capitalize",
    fontWeight: "bold"
  }, selectedLocation.title)), !showInput && serverError && ___EmotionJSX(Box, {
    position: "absolute",
    top: "25px",
    left: "0px"
  }, ___EmotionJSX(Alert, {
    variant: "error",
    timeoutDuration: 5000,
    hideAlert: handleAlertHide,
    showPointer: true,
    pointerProps: {
      ml: "20px"
    }
  }, serverError)))), showInput && ___EmotionJSX(DeliveryLocationPopup, {
    error: serverError,
    hideInput: function hideInput() {
      return setShowInput(false);
    },
    onItemSelected: handleItemSelected
  }));
};